import { render, staticRenderFns } from "./BodyEditor.vue?vue&type=template&id=61a8bb09&"
import script from "./BodyEditor.vue?vue&type=script&lang=js&"
export * from "./BodyEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports